<template>
  <div class="container">
    <h3 style="margin-bottom:16px">{{ editType === 'sheet' ? 'QA Sheet' : '개선사항' }} 등록</h3>
    <div style="margin-bottom:20px">
      <div class="label">해당 위치</div>
      <div>{{ locationText(qa) }}</div>
      <div>{{ qa.location.result }}</div>
    </div>

    <div v-if="editType === 'sheet'" class="flex" style="margin-top: 12px">
      <div v-if="userList.length>0">
        <div class="label">담당자 지정</div>
        <select v-model="qa.task_user">
          <option value="" v-for="(user,idx) in userList" :value="user.id" :key="`user-${idx}`">{{ user.name }}</option>
        </select>
      </div>
      <div style="margin-left:12px">
        <div class="label">우선순위</div>
        <input type="number" v-model.number="qa.priority" style="width:40px">
      </div>
    </div>

    <textarea rows="5" v-model="qa.req_content" :placeholder="`${editType === 'sheet' ? '요청' : '제안'}할 내용을 입력하세요`"></textarea>
    <div class="flex-end" style="margin-top:12px">
      <button class="button is-primary" @click="save">수정하기</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "QaUpdateModal",
    props: {
      editType: {
        type: String,
        default: 'sheet'
      },
      item: {
        type: Object
      }
    },
    created() {
      this.qa = this.cloneItem(this.item);
      this.getUserList();
    },
    data() {
      return {
        url: 'admin/launchpack/qa',
        userList: [],
        qa: undefined

      }
    },
    methods: {
      getUserList() {
        this.$axios.get('admin/member/admin').then(res=>{
          this.userList = res.data;
        });
      },
      locationText() {
        let result = '';
        if (this.item.location.type === 'front_action') {
          result = `[프론트] ${this.qa.location.location_name} > ${this.qa.location.feature_name} > ${this.qa.location.name}`;
        } else {
          result = `[${this.qa.location.type === 'admin_feature' ? '백오피스' : '빌더'}] ${this.qa.location.location_name} > ${this.qa.location.content}`;
        }

        return result;
      },
      valid() {
        let result = true;
        if(this.qa.req_content === '') {
          this.toast(`${this.editType === 'sheet' ? '요청' : '제안'}할 내용을 입력해주세요.`);
          result = false;
        }
        else if(this.editType === 'sheet' && this.qa.task_user_id === 0) {
          this.toast('담당자를 지정해주세요.');
          result = false;
        }

        return result;
      },
      save() {
        if(this.valid()) {
          let params = {};
          if(this.editType === 'sheet') {
            params = {
              task_user_id: this.qa.task_user,
              priority: this.qa.priority
            }
          }
          params.req_content = this.qa.req_content;
          this.$axios.patch(`${this.url}_${this.editType}/${this.qa.id}`, params).then(res => {
            if (res.status === 200) {
              this.toast('수정되었습니다.');
              if(this.editType === 'sheet') {
                this.item.task_user = params.task_user_id;
                this.item.task_user_name = this.userList.filter(i=>{ return i.id === params.task_user_id })[0].name;
                this.item.priority = params.priority;
              }
              this.item.req_content = params.req_content;
              this.$emit('close');
            }
          }).catch(() => {
            this.toast('수정 실패했습니다.');
          });
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    height 500px
    padding 24px
  input
  select
  textarea
    border 1px solid #dddddd
    padding 4px 8px
    border-radius 4px
    max-width 100%

  select
    margin-right 8px
  textarea
    margin-top 12px
    width 100%

  .label
    font-size 13px
    margin-bottom 4px
</style>
